

const LicenseTemplateUrls =
{
    CA: 'app/accounts/licenses/addLicense/CA/licenseCA.html',
    FL: 'app/accounts/licenses/addLicense/FL/licenseFL.html',
    2: 'app/accounts/licenses/addLicense/businessLicense/addBusinessLicense.html',
    1: 'app/accounts/licenses/addLicense/businessLicense/addBusinessLicense.html',

};

export default LicenseTemplateUrls;



// WEBPACK FOOTER //
// ./src/app/config/constants/LicenseTemplateUrls.constant.js